var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var foundation = require( 'foundation' );

var initializeModules = require( './lib/init-modules.js' );
var Header = require( '../../modules/header/header.js' );
var Order_Form_Extended = require( '../../modules/module-order-form-extended/module-order-form-extended.js' );
var BigText = require( '../../assets/js/vendor/bigtext.js' );

var CustomFormValidator = require( '../../../norvital-modular/src/js/lib/custom-form-validator.js' );


$( function () {

	initializeModules();

	var $window = $( window );

	var init = function () {

		CustomFormValidator.addCustomValidations(  $('form.order-form') );
        CustomFormValidator.noEmptyFields(  $('form.order-form') );
		//CustomFormValidator.addCustomValidations( ModuleOrderForm2Step );

		CustomFormValidator.zipLookup( $('form.order-form') );
		//CustomFormValidator.zipLookup( ModuleOrderForm2Step );


	};

    function foundation_fix_check_heights(isresize) {

        const foundationRoot = $('[data-equalizer]');

        foundationRoot.each(function () { // all elements affected by foundation equalizer.
            var thisParent = $(this);
            var foundationChilds = thisParent.find('[data-equalizer-watch]');
            var heighest = 0;

            foundationChilds.each(function () { // all the childs that watches parent.

                if ($(this).get(0).style.height === 'auto') { // If they have height set on auto.

                    if (!thisParent.hasClass('foundation-alternate-height')) {
                        thisParent.foundation('_destroy'); // Remove the control of foundation equalizer over this one.
                        thisParent.addClass('foundation-alternate-height');
                    }
                }
                // Once the control of foundation equalizer is removed....
                if (thisParent.hasClass('foundation-alternate-height')) {
                    $(this).css('min-height', 'auto'); // let's set the min-height to auto, so we can take the real height of element.
                    var thisHeight = $(this).outerHeight();

                    if (thisHeight > heighest) {
                        heighest = thisHeight; // Compare, choose and save the greatest hight.
                    }
                }
            });

            foundationChilds.css('min-height',heighest); // Apply the greatest high to all affected elements.

            // This is for fixing the layout when design change and they are stacked.
            $(('.foundation-alternate-height')).each(function(){
                var parentHeighest = 0;
                var thisChilds = $(this).children();
                thisChilds.each(function(){
                    $(this).css('min-height', 'auto'); // let's set the min-height to auto, so we can take the real height of element.
                    var elementHeight = $(this).outerHeight();

                    if (elementHeight > parentHeighest) {
                        parentHeighest = elementHeight; // Compare, choose and save the greatest hight.
                    }
                });
                thisChilds.css('min-height', parentHeighest);
            })
        });
}

	$( document ).on( 'ready', function () {

		init();

		Header.init();
		Order_Form_Extended.init();

		$( '.order-form' ).on( 'submit', function ( e ) {

			e.preventDefault();

			var self = this;
			var data = $( this ).serialize();

			$.ajax( {
				method: "GET",
				url: NORVITAL.root + 'norvital/v1/order',
				dataType: 'json',
				data: data,
				beforeSend: function ( xhr ) {
					// console.log(data);

					xhr.setRequestHeader( 'X-WP-Nonce', NORVITAL.nonce );
					$( 'input[type="submit"]', self ).prop( 'disabled', true ); // disable button
				},
				success: function ( response ) {
					// console.log(response);

					if ( response.redirect ) {
						window.location.href = response.redirect;
						return;
					}

					$( self ).find( '.message' ).html( 'Your order has been successfully submitted.' );
					$( self ).find( '.callout' ).addClass( 'success' ).fadeIn();

					// console.log('success');
				},
				error: function ( response ) {
					// console.log(response);

					$( self ).find( '.message' ).html( 'There was an error creating your order. Please try again.' );
					$( self ).find( '.callout' ).addClass( 'warning' ).fadeIn();
				}

			} );
		} );

		$( '.order-form .phone-lookup' ).click( function ( e ) {

			e.preventDefault();

			var form = $( this ).closest( '.order-form' );
			var data = form.serialize();

			var $phoneLookup = $( this );
			var phoneLookupText = $phoneLookup.html();

			$.ajax( {
				method: "GET",
				url: NORVITAL.root + 'norvital/v1/phone-lookup',
				dataType: 'json',
				data: data,
				beforeSend: function ( xhr ) {
					// console.log(data);
					xhr.setRequestHeader( 'X-WP-Nonce', NORVITAL.nonce );
					$phoneLookup.html( '<span class="dots"><span>.</span><span>.</span><span>.</span></span>' );
				},
				success: function ( response ) {
					console.log( response );
					var data = jQuery.parseJSON( response.body );

					// First Name
					if ( data.firstname != null ) {

						var firstName = data.firstname;

						if ( data.middlename != null ) {
							firstName = firstName + ' ' + data.middlename;
						}

						$( 'input[name="firstName"]' ).val( firstName );
					}

					// Middle Name
					if ( data.middlename != null ) {
						$( 'input[name="firstName"]' ).val( data.middlename );
					}

					// Last Name
					if ( data.lastname != null ) {
						$( 'input[name="lastName"]' ).val( data.lastname );
					}

					// Address
					if ( data.address != null ) {

						var address = data.address;

						// Street Number
						if ( data.streetnumber != null ) {
							address = address + ' ' + data.streetnumber;
						}

						$( 'input[name="invoiceAddress"]' ).val( address );
					}

					// Zip
					if ( data.postalCode != null ) {
						$( 'input[name="invoiceZipcode"]' ).val( data.postalCode );
					}

					// City
					if ( data.area != null ) {
						$( 'input[name="invoiceCity"]' ).val( data.area );
					}

					$phoneLookup.html( phoneLookupText );

				},
				error: function ( response ) {
					console.log( response );
				}

			} );

		} );

		$( document ).foundation();

	} );

	$window.on( 'load', function () {
        foundation_fix_check_heights(false);
	} );

	$window.resize( function () {

	    var foundationModules = $( '[data-equalizer]:not(.foundation-alternate-height)' );
		Foundation.reInit( foundationModules );

		foundation_fix_check_heights(true);

	} );

} );
